import React from "react";
import { Loader } from "lucide-react";
import styles from "./MessageBubble.module.css";

const MessageBubble = ({ message, formatTime }) => {
  const isUser = message.role === "user";

  return (
    <div
      className={`${styles.messageBubble} ${
        isUser ? styles.messageBubbleUser : styles.messageBubbleAssistant
      }`}
    >
      {message.isLoading ? (
        <div className={styles.loadingIndicator}>
          <Loader size={16} className={styles.loadingSpinner} />
          <span style={{ fontSize: "0.875rem" }}>ИИ думает...</span>
        </div>
      ) : (
        <>
          <p className={styles.messageText}>{message.content}</p>
          {message.model && (
            <p
              className={`${styles.messageModel} ${
                isUser ? styles.messageModelUser : styles.messageModelAssistant
              }`}
            >
              Модель: {message.model}
            </p>
          )}
          <p
            className={`${styles.messageMeta} ${
              isUser ? styles.messageMetaUser : styles.messageMetaAssistant
            }`}
          >
            {formatTime(message.timestamp)}
          </p>
        </>
      )}
    </div>
  );
};

export default MessageBubble;
